import { Heading3 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import { container, screen, spacing } from 'theme';

export const StyledSection = styled.div`
  padding: ${spacing('xl5')} ${spacing('md')};
  max-width: ${container('xl')};
  margin: auto;
  text-align: center;
`;

export const StyledTips = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('xl4')};
  margin-top: ${spacing('xl3')};
`;

export const StyledTip = styled.div`
  display: flex;
  gap: ${spacing('xl')};
  text-align: left;

  @media (min-width: ${screen('md')}) {
    text-align: right;
  }

  > div {
    @media (min-width: ${screen('md')}) {
      width: 50%;
    }
  }

  p {
    margin-bottom: ${spacing('lg')};
  }

  ${Heading3} {
    margin-top: ${spacing('md')};

    &::before {
      left: 0;
      transform: unset;
      @media (min-width: ${screen('md')}) {
        right: 0;
        left: unset;
      }
    }
  }
  @media (min-width: ${screen('md')}) {
    &:nth-child(even) {
      flex-direction: row-reverse;
      text-align: left;

      ${Heading3}::before {
        right: unset;
        left: 0;
      }
    }
  }
`;

export const StyledTipImage = styled.div`
  position: relative;

  img {
    display: none;

    @media (min-width: ${screen('md')}) {
      display: block;
      object-fit: cover;
      width: 100%;
      height: 100%;
      position: absolute;
    }
  }
`;
